import { Html, useProgress } from "@react-three/drei";

import { FancySpinner } from "../../components/common/fancy-spinner.js";

export const OfficeLoader = () => {
  const { progress } = useProgress();

  return (
    <Html>
      <div className="flex flex-col items-center justify-center space-y-4">
        <FancySpinner />
        <span className="text-lg whitespace-nowrap text-gray-600">
          {Math.round(progress)}% Loaded
        </span>
      </div>
    </Html>
  );
};
